import { render, staticRenderFns } from "./tyoskentelyjakso.vue?vue&type=template&id=7cc3b620&scoped=true&"
import script from "./tyoskentelyjakso.vue?vue&type=script&lang=ts&"
export * from "./tyoskentelyjakso.vue?vue&type=script&lang=ts&"
import style0 from "./tyoskentelyjakso.vue?vue&type=style&index=0&id=7cc3b620&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cc3b620",
  null
  
)

export default component.exports